import { useTranslation } from 'react-i18next'
import { BlockTypes } from 'enum/block-type.enum'
import { IBlockInstanceModel } from 'models/block.model'
import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'

interface ConfirmationDeleteProps {
  selected?: IBlockInstanceModel
  show: boolean
  onAccept: () => void
  onClose: () => void
}

export const ConfirmationDelete = ({
  selected,
  show,
  onAccept,
  onClose,
}: ConfirmationDeleteProps) => {
  const { t } = useTranslation()
  const textDict = {
    [BlockTypes.BlockScorm]: t('administration.modal.deleteScormConfirmation'),
    [BlockTypes.BlockEvaluation]: t(
      'administration.modal.deleteEvaluationConfirmation'
    ),
    [BlockTypes.Evaluation]: t(
      'administration.modal.deleteEvaluationConfirmation'
    ),
    [BlockTypes.BlockSurvey]: t(
      'administration.modal.deleteSurveyConfirmation'
    ),
    [BlockTypes.BlockRichText]: t(
      'administration.modal.deleteRichTextConfirmation'
    ),
    [BlockTypes.BlockTask]: t('administration.modal.deleteTaskConfirmation'),
    [BlockTypes.BlockMultimedia]: t(
      'administration.modal.deleteMultimediaBlockConfirmation'
    ),
    [BlockTypes.BlockMeeting]: t(
      'administration.modal.deleteMeetingBlockConfirmation'
    ),
    [BlockTypes.BlockSession]: t(
      'administration.modal.deleteSessionsBlockConfirmation'
    ),
  }
  return (
    <ConfirmationModal
      show={show}
      title=""
      text={`${t('administration.blocks.hasResponsesButCanModify')}. ${
        textDict[selected?.blockType || ''] ||
        t('administration.modal.deleteConfirmation')
      }`}
      acceptButtonText={t('components.modal.buttons.delete')}
      onAccept={onAccept}
      onClose={onClose}
    />
  )
}

export default ConfirmationDelete
